import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import agent from '../../../agent';

const DELIVERY_OPTIONS = [
    { label: 'Все', value: '' },
    { label: 'Да', value: 'true' },
    { label: 'Нет', value: 'false' },
];

const PAGE_SIZE_OPTIONS = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
];

const BOOL_FIELDS = [
    { field: 'alemtatA', label: 'AlemTat A' },
    { field: 'alemtatC', label: 'AlemTat C' },
    { field: 'alemtatEco', label: 'AlemTat ECO' },
    { field: 'alemtatE', label: 'AlemTat E' },
    { field: 'dpdBzp', label: 'DPD BZP' },
    { field: 'dpdPcl', label: 'DPD PCL' },
    { field: 'dpdCur1Auto', label: 'DPD CUR 1 (авто)' },
    { field: 'dpdCur2Avia', label: 'DPD CUR 2 (авиа)' },
    { field: 'gopostStandardP154', label: 'GoPost Standard – P154' },
    { field: 'gopostCityP153', label: 'GoPost City посылка – P153' },
    { field: 'gopostExpressP151', label: 'GoPost Express посылка – P151' },
    { field: 'exlineStandard', label: 'Exline standard' },
    { field: 'exlineExpress', label: 'Exline express' },
    { field: 'privateCargoTransport', label: 'ЧГП' },
    { field: 'sparkAuto', label: 'SPARK Авто' },
    { field: 'sparkAvia', label: 'SPARK Авиа' },
];

const emptyForm = () => ({
    code: '',
    nameRu: '',
    deliveryAvailability: false,
    packagingRequirements: '',
    alemtatA: false,
    alemtatC: false,
    alemtatEco: false,
    alemtatE: false,
    dpdBzp: false,
    dpdPcl: false,
    dpdCur1Auto: false,
    dpdCur2Avia: false,
    gopostStandardP154: false,
    gopostCityP153: false,
    gopostExpressP151: false,
    exlineStandard: false,
    exlineExpress: false,
    privateCargoTransport: false,
    sparkAuto: false,
    sparkAvia: false,
});

const deliveryLabel = (val) => {
    if (val === true) return 'Да';
    if (val === false) return 'Нет';
    return 'Отсутствует';
};

const boolLabel = (val) => (val ? 'Да' : 'Нет');

const gb = { borderLeft: '1px solid #c8c8c8' };

const headerGroup = (
    <ColumnGroup>
        <Row>
            <Column selectionMode="multiple" rowSpan={2} style={{ width: '3rem' }} />
            <Column header="Код" rowSpan={2} sortable field="code" style={{ minWidth: '90px', ...gb }} />
            <Column header="Наименование на русском" rowSpan={2} sortable field="nameRu" style={{ minWidth: '200px', ...gb }} />
            <Column header="Наличие доставки" rowSpan={2} sortable field="deliveryAvailability" style={{ minWidth: '100px', ...gb }} />
            <Column header="Alem-Tat" colSpan={4} style={{ textAlign: 'center', ...gb }} />
            <Column header="DPD" colSpan={4} style={{ textAlign: 'center', ...gb }} />
            <Column header="GoPost" colSpan={3} style={{ textAlign: 'center', ...gb }} />
            <Column header="EXLINE" colSpan={2} style={{ textAlign: 'center', ...gb }} />
            <Column header="ЧГП" rowSpan={2} style={{ minWidth: '60px', textAlign: 'center', ...gb }} />
            <Column header="SPARK" colSpan={2} style={{ textAlign: 'center', ...gb }} />
            <Column header="Требования по упаковке" rowSpan={2} style={{ minWidth: '140px', ...gb }} />
            <Column header="Действия" rowSpan={2} style={{ width: '80px', ...gb }} />
        </Row>
        <Row>
            <Column header="A" style={{ minWidth: '50px', textAlign: 'center', ...gb }} />
            <Column header="C" style={{ minWidth: '50px', textAlign: 'center' }} />
            <Column header="ECO" style={{ minWidth: '55px', textAlign: 'center' }} />
            <Column header="E" style={{ minWidth: '50px', textAlign: 'center' }} />
            <Column header="BZP" style={{ minWidth: '55px', textAlign: 'center', ...gb }} />
            <Column header="PCL" style={{ minWidth: '55px', textAlign: 'center' }} />
            <Column header="DPD CUR 1 (авто)" style={{ minWidth: '100px', textAlign: 'center' }} />
            <Column header="DPD CUR 2 (авиа)" style={{ minWidth: '100px', textAlign: 'center' }} />
            <Column header="GoPost Standard посылка – P154" style={{ minWidth: '120px', textAlign: 'center', ...gb }} />
            <Column header="GoPost City посылка – P153" style={{ minWidth: '110px', textAlign: 'center' }} />
            <Column header="GoPost Express посылка – P151" style={{ minWidth: '120px', textAlign: 'center' }} />
            <Column header="Exline standard" style={{ minWidth: '90px', textAlign: 'center', ...gb }} />
            <Column header="Exline express" style={{ minWidth: '90px', textAlign: 'center' }} />
            <Column header="Авто" style={{ minWidth: '60px', textAlign: 'center', ...gb }} />
            <Column header="Авиа" style={{ minWidth: '60px', textAlign: 'center' }} />
        </Row>
    </ColumnGroup>
);

const OktruServiceCatalog = () => {
    const [rows, setRows] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const [filterNameRu, setFilterNameRu] = useState('');
    const [filterCode, setFilterCode] = useState('');
    const [filterDelivery, setFilterDelivery] = useState('');

    const [categoryOptions, setCategoryOptions] = useState([]);

    const [selected, setSelected] = useState([]);

    const [showDialog, setShowDialog] = useState(false);
    const [form, setForm] = useState(emptyForm());
    const [dialogLoading, setDialogLoading] = useState(false);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleteBulk, setDeleteBulk] = useState(false);

    const [importLoading, setImportLoading] = useState(false);
    const fileInputRef = useRef(null);
    const toast = useRef(null);

    const activeFilters = useRef({});
    const activeSort = useRef({ field: null, order: null });

    const loadPage = useCallback((p, ps, filters, sf = activeSort.current.field, so = activeSort.current.order) => {
        setLoading(true);
        const params = {};
        if (filters.nameRu) params.nameRu = filters.nameRu;
        if (filters.code) params.code = filters.code;
        if (filters.deliveryAvailability !== '') params.deliveryAvailability = filters.deliveryAvailability;
        if (sf) params.sort = `${sf},${so === 1 ? 'asc' : 'desc'}`;
        agent.Oktru.getPage(params, p, ps)
            .then(res => {
                setRows(res?.content ?? []);
                setTotalElements(res?.totalElements ?? 0);
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Ошибка', detail: 'Не удалось загрузить данные', life: 3000 });
                setRows([]);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        agent.ProductCategory.all('', '', 0, 200).then(res => {
            const opts = (res?.content ?? []).map(c => ({ label: c.name_ru, value: c.name_ru }));
            setCategoryOptions([{ label: 'Выберите категорию', value: '' }, ...opts]);
        }).catch(() => {});
    }, []);

    useEffect(() => {
        loadPage(0, pageSize, {});
    }, []);

    const handleSearch = () => {
        const filters = {
            nameRu: filterNameRu,
            code: filterCode,
            deliveryAvailability: filterDelivery,
        };
        activeFilters.current = filters;
        setPage(0);
        loadPage(0, pageSize, filters);
        setSelected([]);
    };

    const handleReset = () => {
        setFilterNameRu('');
        setFilterCode('');
        setFilterDelivery('');
        activeFilters.current = {};
        setPage(0);
        setSelected([]);
        loadPage(0, pageSize, {});
    };

    const onPageChange = (e) => {
        setPage(e.page);
        setPageSize(e.rows);
        loadPage(e.page, e.rows, activeFilters.current);
    };

    const onSort = (e) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
        activeSort.current = { field: e.sortField, order: e.sortOrder };
        setPage(0);
        loadPage(0, pageSize, activeFilters.current, e.sortField, e.sortOrder);
    };

    const openCreate = () => {
        setForm(emptyForm());
        setShowDialog(true);
    };

    const openEdit = (row) => {
        setForm({ ...row });
        setShowDialog(true);
    };

    const handleSave = () => {
        if (!form.code || !form.nameRu) {
            toast.current.show({ severity: 'warn', summary: 'Внимание', detail: 'Код и наименование обязательны', life: 3000 });
            return;
        }
        setDialogLoading(true);
        const isEdit = !!form.id;
        const call = isEdit ? agent.Oktru.update(form) : agent.Oktru.create(form);
        call
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Готово', detail: isEdit ? 'Запись обновлена' : 'Запись создана', life: 3000 });
                setShowDialog(false);
                loadPage(page, pageSize, activeFilters.current);
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Ошибка', detail: 'Не удалось сохранить', life: 3000 });
            })
            .finally(() => setDialogLoading(false));
    };

    const confirmDelete = (row) => {
        setDeleteTarget(row);
        setDeleteBulk(false);
        setShowDeleteDialog(true);
    };

    const confirmBulkDelete = () => {
        setDeleteBulk(true);
        setShowDeleteDialog(true);
    };

    const handleDelete = () => {
        const targets = deleteBulk ? selected : [deleteTarget];
        setShowDeleteDialog(false);
        Promise.all(targets.map(r => agent.Oktru.softDelete(r.id)))
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Готово', detail: 'Удалено', life: 3000 });
                setSelected([]);
                loadPage(page, pageSize, activeFilters.current);
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Ошибка', detail: 'Не удалось удалить', life: 3000 });
            });
    };

    const handleCsvImport = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        e.target.value = '';
        setImportLoading(true);
        agent.Oktru.importCsv(file)
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Импорт', detail: 'CSV импортирован', life: 3000 });
                loadPage(page, pageSize, activeFilters.current);
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка импорта CSV', life: 3000 });
            })
            .finally(() => setImportLoading(false));
    };

    const setFormField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

    const boolBody = (field) => (row) => (
        <span style={{ display: 'block', textAlign: 'center' }}>{boolLabel(row[field])}</span>
    );

    const actionsBody = (row) => (
        <div style={{ display: 'flex', gap: '4px' }}>
            <Button icon="pi pi-pencil" className="p-button-text p-button-sm p-button-info" onClick={() => openEdit(row)} />
            <Button icon="pi pi-trash" className="p-button-text p-button-sm p-button-danger" onClick={() => confirmDelete(row)} />
        </div>
    );

    return (
        <div style={{ padding: '24px' }}>
            <Toast ref={toast} />
            <h2 style={{ marginBottom: '20px' }}>ОКТРУ справочник по услугам</h2>

            {/* Filters */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px', alignItems: 'end' }}>
                <div>
                    <div style={{ marginBottom: '4px', fontSize: '13px', color: '#666' }}>Категория товара</div>
                    <Dropdown
                        value={filterNameRu}
                        options={categoryOptions}
                        onChange={e => setFilterNameRu(e.value)}
                        placeholder="Выберите категорию"
                        style={{ width: '100%' }}
                        showClear
                        filter
                    />
                </div>
                <div>
                    <div style={{ marginBottom: '4px', fontSize: '13px', color: '#666' }}>Код</div>
                    <InputText
                        value={filterCode}
                        onChange={e => setFilterCode(e.target.value)}
                        placeholder="Введите код"
                        style={{ width: '100%' }}
                    />
                </div>
                <div>
                    <div style={{ marginBottom: '4px', fontSize: '13px', color: '#666' }}>Наличие доставки</div>
                    <Dropdown
                        value={filterDelivery}
                        options={DELIVERY_OPTIONS}
                        onChange={e => setFilterDelivery(e.value)}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button label="Найти" icon="pi pi-search" onClick={handleSearch} />
                    <Button label="Сбросить" icon="pi pi-refresh" className="p-button-warning" onClick={handleReset} />
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <Button
                        label="Выбрать CSV файл"
                        icon="pi pi-upload"
                        className="p-button-outlined"
                        loading={importLoading}
                        onClick={() => fileInputRef.current?.click()}
                    />
                    <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} onChange={handleCsvImport} />
                    <Button
                        label="Добавить категорию товара"
                        icon="pi pi-plus"
                        className="p-button-text"
                        onClick={openCreate}
                    />
                </div>
            </div>

            {/* Bulk delete bar */}
            {selected.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
                    <span>Выбрано: <strong>{selected.length}</strong></span>
                    <Button
                        label="Удалить выбранное"
                        icon="pi pi-trash"
                        className="p-button-danger p-button-outlined p-button-sm"
                        onClick={confirmBulkDelete}
                    />
                </div>
            )}

            <DataTable
                value={rows}
                headerColumnGroup={headerGroup}
                selection={selected}
                onSelectionChange={e => setSelected(e.value)}
                dataKey="id"
                loading={loading}
                emptyMessage="Данные не найдены"
                scrollable
                scrollHeight="600px"
                style={{ fontSize: '13px' }}
                sortMode="single"
                sortField={sortField}
                sortOrder={sortOrder}
                onSort={onSort}
            >
                <Column selectionMode="multiple" style={{ width: '3rem' }} />
                <Column field="code" sortable />
                <Column field="nameRu" sortable />
                <Column field="deliveryAvailability" body={row => deliveryLabel(row.deliveryAvailability)} sortable />
                <Column field="alemtatA" body={boolBody('alemtatA')} />
                <Column field="alemtatC" body={boolBody('alemtatC')} />
                <Column field="alemtatEco" body={boolBody('alemtatEco')} />
                <Column field="alemtatE" body={boolBody('alemtatE')} />
                <Column field="dpdBzp" body={boolBody('dpdBzp')} />
                <Column field="dpdPcl" body={boolBody('dpdPcl')} />
                <Column field="dpdCur1Auto" body={boolBody('dpdCur1Auto')} />
                <Column field="dpdCur2Avia" body={boolBody('dpdCur2Avia')} />
                <Column field="gopostStandardP154" body={boolBody('gopostStandardP154')} />
                <Column field="gopostCityP153" body={boolBody('gopostCityP153')} />
                <Column field="gopostExpressP151" body={boolBody('gopostExpressP151')} />
                <Column field="exlineStandard" body={boolBody('exlineStandard')} />
                <Column field="exlineExpress" body={boolBody('exlineExpress')} />
                <Column field="privateCargoTransport" body={boolBody('privateCargoTransport')} />
                <Column field="sparkAuto" body={boolBody('sparkAuto')} />
                <Column field="sparkAvia" body={boolBody('sparkAvia')} />
                <Column field="packagingRequirements" body={row => row.packagingRequirements || '-'} />
                <Column body={actionsBody} />
            </DataTable>

            {/* Pagination */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px' }}>
                <span style={{ fontSize: '13px', color: '#666' }}>Показано по:</span>
                <Dropdown
                    value={pageSize}
                    options={PAGE_SIZE_OPTIONS}
                    onChange={e => {
                        setPageSize(e.value);
                        setPage(0);
                        loadPage(0, e.value, activeFilters.current);
                    }}
                    style={{ width: '80px' }}
                />
                <Paginator
                    first={page * pageSize}
                    rows={pageSize}
                    totalRecords={totalElements}
                    onPageChange={onPageChange}
                    template="PrevPageLink PageLinks NextPageLink"
                    style={{ flex: 1 }}
                />
            </div>

            {/* Create/Edit dialog */}
            <Dialog
                header={form.id ? `Редактировать #${form.id}` : 'Добавить категорию товара'}
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{ width: '680px' }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button label="Отмена" className="p-button-text" onClick={() => setShowDialog(false)} />
                        <Button label="Сохранить" loading={dialogLoading} onClick={handleSave} />
                    </div>
                }
            >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>Код <span style={{ color: 'red' }}>*</span></label>
                        <InputText value={form.code} onChange={e => setFormField('code', e.target.value)} style={{ width: '100%' }} disabled={!!form.id} />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>Наименование на русском <span style={{ color: 'red' }}>*</span></label>
                        <InputText value={form.nameRu} onChange={e => setFormField('nameRu', e.target.value)} style={{ width: '100%' }} />
                    </div>
                    <div style={{ gridColumn: 'span 2' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>Требования к упаковке</label>
                        <InputTextarea value={form.packagingRequirements || ''} onChange={e => setFormField('packagingRequirements', e.target.value)} style={{ width: '100%', resize: 'vertical' }} rows={3} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '20px' }}>
                        <Checkbox checked={!!form.deliveryAvailability} onChange={e => setFormField('deliveryAvailability', e.checked)} inputId="delAvail" />
                        <label htmlFor="delAvail" style={{ fontSize: '13px' }}>Наличие доставки</label>
                    </div>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '12px', color: '#444' }}>Перевозчики</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        {BOOL_FIELDS.map(({ field, label }) => (
                            <div key={field} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Checkbox
                                    checked={!!form[field]}
                                    onChange={e => setFormField(field, e.checked)}
                                    inputId={field}
                                />
                                <label htmlFor={field} style={{ fontSize: '13px' }}>{label}</label>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            {/* Delete confirmation */}
            <Dialog
                header="Подтверждение удаления"
                visible={showDeleteDialog}
                onHide={() => setShowDeleteDialog(false)}
                style={{ width: '400px' }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button label="Отмена" className="p-button-text" onClick={() => setShowDeleteDialog(false)} />
                        <Button label="Удалить" className="p-button-danger" onClick={handleDelete} />
                    </div>
                }
            >
                <div>
                {deleteBulk
                    ? <p style={{ wordBreak: 'break-word', margin: 0 }}>Удалить выбранные записи ({selected.length} шт.)?</p>
                    : <p style={{ wordBreak: 'break-word', margin: 0 }}>Удалить запись <strong>{deleteTarget?.code}</strong> — {deleteTarget?.nameRu}?</p>
                }
                </div>
            </Dialog>
        </div>
    );
};

export default OktruServiceCatalog;
